module.exports = __webpack_public_path__ + "static/media/iphone.e3c54192.png";